export default __webpack_public_path__ + "static/media/hertz_24.e5e9b5c8.svg";